import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col space-y-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl w-full h-full md:text-4xl text-center tracking-wide z-50 break-words" }, " Appuyez pour recommencer la création d'une partie avec les mêmes paramètres. ", -1)

import BigTitle from "@/components/Title/BigTitle.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'GameFinished',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BigTitle, {
      title: "Partie terminée !",
      class: "text-center"
    }),
    _hoisted_2
  ]))
}
}

})